import { Link } from 'react-router-dom'
import { ArrowRight, Eye } from 'lucide-react'
import { formatVND } from '@/lib/formatters'
import { StatusBadge } from './StatusBadge'
import type { AdminOrder } from '../../model/types'

export function RecentOrdersTable({ orders }: { orders: AdminOrder[] }) {
  return (
    <div className="bg-surface border border-border rounded-xl shadow-card overflow-hidden">
      <div className="px-5 h-14 border-b border-border flex items-center justify-between">
        <h3 className="font-semibold text-text">Đơn hàng mới nhất</h3>
        <Link to="/admin/don-hang" className="text-sm text-brand-600 hover:underline inline-flex items-center gap-1 font-medium">
          Xem tất cả <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-muted text-xs uppercase">
            <tr>
              <th className="text-left px-5 py-3 font-medium">Mã đơn</th>
              <th className="text-left px-5 py-3 font-medium">Khách hàng</th>
              <th className="text-left px-5 py-3 font-medium">SĐT</th>
              <th className="text-left px-5 py-3 font-medium">Tổng</th>
              <th className="text-left px-5 py-3 font-medium">Trạng thái</th>
              <th className="text-left px-5 py-3 font-medium">Thời gian</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-border hover:bg-slate-50">
                <td className="px-5 py-3 font-mono text-xs font-semibold text-brand-700">{o.id}</td>
                <td className="px-5 py-3 font-medium text-text">{o.customer}</td>
                <td className="px-5 py-3 text-muted">{o.phone}</td>
                <td className="px-5 py-3 font-semibold text-text">{formatVND(o.total)}</td>
                <td className="px-5 py-3"><StatusBadge status={o.status} /></td>
                <td className="px-5 py-3 text-muted text-xs">{o.createdAt}</td>
                <td className="px-5 py-3 text-right">
                  <Link
                    to={`/admin/don-hang/${o.id}`}
                    className="inline-flex items-center justify-center w-8 h-8 rounded-md hover:bg-brand-50 text-brand-600 transition"
                    aria-label="Xem chi tiết"
                  >
                    <Eye className="w-4 h-4" />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
